import { useTranslation } from "react-i18next";

interface IProps {
    message: string
}

const DataNotFoundPage = (props: IProps) => {
    const [t] = useTranslation()

    return (
        <div className="flex flex-col grow overflow-auto">
            <img src="assets/images/searching.svg" className="w-full max-h-80 mx-auto" />
            <div className="text-sm font-semibold text-center mt-5">{props.message}</div>
        </div>)
}

export default DataNotFoundPage;
